export default __webpack_public_path__ + "static/media/adicionar-arquivos-imagem.25d75fe7.svg";